// @ts-strict-ignore
import { useLocalization } from '@components/Localization'
import { useNotifications } from '@components/NotificationsProvider'
import { LinariaLink } from '@components/gassan-ui/LinariaLink'
import {
  UpdatePreferencesInput,
  usePreferencesQuery,
  useUpdatePreferencesMutation,
} from '@generated'
import { useTranslation } from 'next-i18next'
import { FC, useState } from 'react'

type AddToPreferencesButtonProps = {
  variant: 'brands' | 'stores'
  preferenceNumber: number
}

export const AddToPreferencesButton: FC<AddToPreferencesButtonProps> = ({
  variant,
  preferenceNumber,
}) => {
  const [status, setStatus] = useState<'loading' | 'idle'>('idle')
  const [, updatePrefences] = useUpdatePreferencesMutation()
  const { addNotification } = useNotifications()
  const [{ data: preferences }] = usePreferencesQuery()
  const { parseGraphQlError } = useLocalization()
  const { t } = useTranslation('account')
  const preferenceTypeId = variant === 'brands' ? 1 : 3

  return preferences && preferences.preferences ? (
    <LinariaLink
      variant="brown"
      as="button"
      onClick={saveAsPreferenceStore}
      disabled={status === 'loading'}
    >
      {t(`preferences.${variant === 'brands' ? 'saveAsPreferenceBrand' : 'saveAsPreferenceStore'}`)}
    </LinariaLink>
  ) : null

  async function saveAsPreferenceStore() {
    setStatus('loading')
    const alreadyPreferred = checkIfAlreadyPreferred()
    if (alreadyPreferred) {
      setStatus('idle')
      return addNotification({
        variant: 'simple-confirmation',
        label: t(`preferences.${variant}.alreadySaved`),
      })
    }

    let otherPreferences = preferences.preferences.filter(
      (preference) => preference.preference_type_id !== preferenceTypeId,
    )
    const preferenceType = preferences.preferences.find(
      (item) => item.preference_type_id === preferenceTypeId,
    )
    const updatedPreferences = preferenceType.preferences.map((item) => {
      if (item.preference_no === preferenceNumber) {
        return {
          ...item,
          isSelected: true,
        }
      } else {
        return {
          ...item,
        }
      }
    })
    const updatedPreferenceType = {
      ...preferenceType,
      preferences: updatedPreferences,
    } as UpdatePreferencesInput

    const result = await updatePrefences({
      input: [...otherPreferences, updatedPreferenceType] as UpdatePreferencesInput[],
    })
    if (result.error) {
      setStatus('idle')
      addNotification({
        variant: 'error',
        label: parseGraphQlError(result.error.message),
      })
    } else {
      setStatus('idle')
      addNotification({
        variant: 'simple-confirmation',
        label: t('preferences.saved'),
      })
    }
  }

  function checkIfAlreadyPreferred() {
    const preferenceType = preferences.preferences.find(
      (item) => item.preference_type_id === preferenceTypeId,
    )
    const preferenceItem = preferenceType.preferences.find(
      (item) => item.preference_no === preferenceNumber,
    )

    if (preferenceItem && preferenceItem.isSelected) {
      return true
    }
    return false
  }
}
